// extracted by mini-css-extract-plugin
export var header = "_a6-0";